import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/Login.vue';
import Register from './components/Register.vue';

Vue.use(Router);

export const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login/:token',
      name: 'logintoken',
      component: () => import('./components/LoginToken.vue')
    },
    {
      path: '/user_management',
      name: 'user_management',
      // lazy-loaded
      component: () => import('./components/Users.vue')
    },
    {
      path: '/image_upload',
      name: 'image_upload',
      // lazy-loaded
      component: () => import('./components/upload.vue')
    },
    {
      path: '/role_management',
      name: 'role_management',
      // lazy-loaded
      component: () => import('./components/Roles.vue')
    },
    {
      path: '/reports/accruals_assets',
      name: 'accruals_assets',
      // lazy-loaded
      component: () => import('./components/Report.AssetAccrual.vue')
    },
    {
      path: '/reports/accruals_liabilities',
      name: 'accruals_liabilities',
      // lazy-loaded
      component: () => import('./components/Report.LiabilitiesAccrual.vue')
    },
    {
      path: '/reports/equity_holdingls',
      name: 'equity_holdingls',
      // lazy-loaded
      component: () => import('./components/Report.EquityHoldingLs.vue')
    },
    {
      path: '/reports/transaction_history',
      name: 'transaction_history',
      // lazy-loaded
      component: () => import('./components/Report.TransactionHistory.vue')
    },
    {
      path: '/reports/counterparty_exposure',
      name: 'counterparty_exposure',
      // lazy-loaded
      component: () => import('./components/Report.CounterpartyExposure.vue')
    },
    {
      path: '/reports/trading_margins',
      name: 'trading_margins',
      // lazy-loaded
      component: () => import('./components/Report.TradingMargin.vue')
    },
    {
      path: '/reports/trading_margin_allocations',
      name: 'trading_margin_allocations',
      // lazy-loaded
      component: () => import('./components/Report.TradingMarginAllocations.vue')
    },
    {
      path: '/reports/mm_rates_rpt',
      name: 'mm_rates_rpt',
      // lazy-loaded
      component: () => import('./components/Report.MoneyMarketRates.vue')
    },
    {
      path: '/reports/client_listing',
      name: 'client_listing',
      // lazy-loaded
      component: () => import('./components/Report.ClientListing.vue')
    },
    {
      path: '/reports/client_custodians',
      name: 'client_custodians',
      // lazy-loaded
      component: () => import('./components/Report.ClientCustodians.vue')
    },
    {
      path: '/reports/client_fees',
      name: 'client_fees',
      // lazy-loaded
      component: () => import('./components/Report.ClientFees.vue')
    },
    {
      path: '/reports/pending_deals',
      name: 'pending_deals',
      // lazy-loaded
      component: () => import('./components/Report.PendingDeals.vue')
    },
    {
      path: '/reports/settlement_report',
      name: 'settlement_report',
      // lazy-loaded
      component: () => import('./components/Report.SettlementReport.vue')
    },
    {
      path: '/reports/financial_maturity_report',
      name: 'financial_maturity_report',
      // lazy-loaded
      component: () => import('./components/Report.FinancialMaturityReport.vue')
    },
    // {
    //   path: '/reports/portfolio_statement',
    //   name: 'portfolio_statement',
    //   // lazy-loaded
    //   component: () => import('./components/Report.PortfolioStatement.vue')
    // },
    {
      path: '/reports/financial_entries',
      name: 'financial_entries',
      // lazy-loaded
      component: () => import('./components/Report.FinancialDailyGeneratedEntries.vue')
    },
    {
      path: '/reports/financial_account_statement',
      name: 'financial_account_statement',
      // lazy-loaded
      component: () => import('./components/Report.FinancialAccountStatement.vue')
    },
    {
      path: '/reports/client_valuation',
      name: 'client_valuation',
      // lazy-loaded
      component: () => import('./components/Report.ClientValuation.vue')
    },
    {
      path: '/reports/purchase_sales&maturities',
      name: 'purchase_sales&maturities',
      // lazy-loaded
      component: () => import('./components/Report.PurchaseSalesAndMaturities.vue')
    },
    {
      path: '/reports/generated_entries',
      name: 'generated_entries',
      // lazy-loaded
      component: () => import('./components/Report.GeneratedEntries.vue')
    },
    {
      path: '/reports/income_paid',
      name: 'income_paid',
      // lazy-loaded
      component: () => import('./components/Report.IncomePaid.vue')
    },
    {
      path: '/reports/equities_holdings',
      name: 'equities_holdings',
      // lazy-loaded
      component: () => import('./components/Report.EquitiesHoldings.vue')
    },
    {
      path: '/reports/contribution_withdrawals',
      name: 'contribution_withdrawals',
      // lazy-loaded
      component: () => import('./components/Report.ContributionsAndWithdrawals.vue')
    },
    {
      path: '/reports/interest_bearing_assets',
      name: 'interest_bearing_assets',
      // lazy-loaded
      component: () => import('./components/Report.InterestBearingAssets.vue')
    },
    {
      path: '/reports/consolidated_valuation',
      name: 'consolidated_valuation',
      // lazy-loaded
      component: () => import('./components/Report.ConsolidatedValuation.vue')
    },
    {
      path: '/reports/performance',
      name: 'performance',
      // lazy-loaded
      component: () => import('./components/Report.Performance.vue')
    },
    {
      path: '/reports/asset_performance',
      name: 'asset_performance',
      // lazy-loaded
      component: () => import('./components/Report.PerformanceForAssets.vue')
    },
    {
      path: '/reports/ind_outstanding_settlements',
      name: 'ind_outstanding_settlements',
      // lazy-loaded
      component: () => import('./components/Report.IndOutstandingSettlements.vue')
    },
    {
      path: '/reports/audit_trail',
      name: 'audit_trail',
      // lazy-loaded
      component: () => import('./components/Report.AuditTrail.vue')
    },
    {
      path: '/reports/nmi_rebate_rates',
      name: 'nmi_rebate_rates',
      // lazy-loaded
      component: () => import('./components/Report.NMIRebateRates.vue')
    },
    {
      path: '/reports/kyc_report',
      name: 'kyc_report',
      // lazy-loaded
      component: () => import('./components/Report.KYC.vue')
    },
    {
      path: '/reports/client_fum',
      name: 'client_fum',
      // lazy-loaded
      component: () => import('./components/Report.FundsUnderManagement.vue')
    },

    {
      path: '/reports/property_holding',
      name: 'property_holding',
      // lazy-loaded
      component: () => import('./components/Report.PropertyHolding.vue')
    },

    // {
    //   path: '/maintenance/activations',
    //   name: 'activations',
    //   // lazy-loaded
    //   component: () => import('./components/Activations.vue')
    // },
    {
      path: '/maintenance/bank_account_types',
      name: 'bank_account_types',
      // lazy-loaded
      component: () => import('./components/BankAccountTypes.vue')
    },
    {
      path: '/maintenance/banks',
      name: 'banks',
      // lazy-loaded
      component: () => import('./components/Banks.vue')
    },
    {
      path: '/maintenance/bank_branches',
      name: 'bank_branches',
      // lazy-loaded
      component: () => import('./components/BankBranches.vue')
    },
    {
      path: '/maintenance/offices',
      name: 'offices',
      // lazy-loaded
      component: () => import('./components/Offices.vue')
    },
    {
      path: '/maintenance/nmi_rebate_rates',
      name: 'nmi_rebate_rates',
      // lazy-loaded
      component: () => import('./components/NMIRebateRates.vue')
    },
    {
      path: '/maintenance/bond_investment_types',
      name: 'bond_investment_types',
      // lazy-loaded
      component: () => import('./components/BondInvestmentTypes.vue')
    },
    {
      path: '/maintenance/call_account_types',
      name: 'call_account_types',
      // lazy-loaded
      component: () => import('./components/CallAccountTypes.vue')
    },
    {
      path: '/maintenance/countries',
      name: 'countries',
      // lazy-loaded
      component: () => import('./components/Countries.vue')
    },
    {
      path: '/maintenance/cities',
      name: 'cities',
      // lazy-loaded
      component: () => import('./components/Cities.vue')
    },
    {
      path: '/maintenance/client_types',
      name: 'client_types',
      // lazy-loaded
      component: () => import('./components/ClientTypes.vue')
    },
    {
      path: '/maintenance/currencies',
      name: 'currencies',
      // lazy-loaded
      component: () => import('./components/Currencies.vue')
    },
    {
      path: '/maintenance/dealer_groups',
      name: 'dealer_groups',
      // lazy-loaded
      component: () => import('./components/DealerGroups.vue')
    },
    {
      path: '/maintenance/delivery_methods',
      name: 'delivery_methods',
      // lazy-loaded
      component: () => import('./components/DeliveryMethods.vue')
    },
    {
      path: '/maintenance/contribution_methods',
      name: 'contribution_methods',
      // lazy-loaded
      component: () => import('./components/DepositMethods.vue')
    },
    // {
    //   path: '/maintenance/financial_years',
    //   name: 'financial_years',
    //   // lazy-loaded
    //   component: () => import('./components/FinancialYears.vue')
    // },
    {
      path: '/maintenance/frequencies',
      name: 'frequencies',
      // lazy-loaded
      component: () => import('./components/Frequencies.vue')
    },
    {
      path: '/maintenance/holidays',
      name: 'holidays',
      // lazy-loaded
      component: () => import('./components/Holidays.vue')
    },
    {
      path: '/maintenance/identity_types',
      name: 'identity_types',
      // lazy-loaded
      component: () => import('./components/IdentityTypes.vue')
    },
    {
      path: '/maintenance/override_reasons',
      name: 'override_reasons',
      // lazy-loaded
      component: () => import('./components/OverrideReasons.vue')
    },
    {
      path: '/maintenance/property_types',
      name: 'property_types',
      // lazy-loaded
      component: () => import('./components/PropertyTypes.vue')
    },
    {
      path: '/maintenance/rejection_reasons',
      name: 'rejection_reasons',
      // lazy-loaded
      component: () => import('./components/RejectionReasons.vue')
    },
    {
      path: '/maintenance/sectors',
      name: 'sectors',
      // lazy-loaded
      component: () => import('./components/Sectors.vue')
    },
    {
      path: '/maintenance/account_statuses',
      name: 'account_statuses',
      // lazy-loaded
      component: () => import('./components/AccountStatuses.vue')
    },
    {
      path: '/maintenance/custodian_statuses',
      name: 'custodian_statuses',
      // lazy-loaded
      component: () => import('./components/CustodianStatuses.vue')
    },
    {
      path: '/maintenance/property_statuses',
      name: 'property_statuses',
      // lazy-loaded
      component: () => import('./components/PropertyStatuses.vue')
    },
    {
      path: '/maintenance/exchange_pairs',
      name: 'exchange_pairs',
      // lazy-loaded
      component: () => import('./components/ExchangePairs.vue')
    },
    {
      path: '/maintenance/titles',
      name: 'titles',
      // lazy-loaded
      component: () => import('./components/Titles.vue')
    },
    {
      path: '/maintenance/transaction_codes',
      name: 'transaction_codes',
      // lazy-loaded
      component: () => import('./components/TransactionCodes.vue')
    },
    {
      path: '/general_settings',
      name: 'general_settings',
      // lazy-loaded
      component: () => import('./components/GeneralSettings.vue')
    },
    {
      path: '/administration/client_onboarding',
      name: 'client_onboarding',
      // lazy-loaded
      component: () => import('./components/ClientOnboarding.vue')
    },
    {
      path: '/administration/client_signatories',
      name: 'client_signatories',
      // lazy-loaded
      component: () => import('./components/ClientSignatories.vue')
    },
    {
      path: '/administration/instrument_types',
      name: 'instrument_types',
      // lazy-loaded
      component: () => import('./components/InterestBearingInstrumentTypes.vue')
    },
    {
      path: '/administration/unit_trust',
      name: 'unit_trust',
      // lazy-loaded
      component: () => import('./components/UnitTrustDefination.vue')
    },
    {
      path: '/administration/unit_trust_redemption',
      name: 'unit_trust_redemption',
      // lazy-loaded
      component: () => import('./components/UnitTrustRedemption.vue')
    },
    {
      path: '/administration/unit_trust_subscription',
      name: 'unit_trust_subscription',
      // lazy-loaded
      component: () => import('./components/UnitTrustSubscription.vue')
    },
    {
      path: '/administration/unit_distribution',
      name: 'unit_distribution',
      // lazy-loaded
      component: () => import('./components/UnitDistribution.vue')
    },
    // {
    //   path: '/administration/counterparty_limits',
    //   name: 'counterparty_limits',
    //   // lazy-loaded
    //   component: () => import('./components/CounterpartyLimits.vue')
    // },
    {
      path: '/administration/dealer_limits',
      name: 'dealer_limits',
      // lazy-loaded
      component: () => import('./components/DealerLimits.vue')
    },
    {
      path: '/administration/tax_rates',
      name: 'tax_rates',
      // lazy-loaded
      component: () => import('./components/TaxRates.vue')
    },
    {
      path: '/administration/taxes',
      name: 'taxes',
      // lazy-loaded
      component: () => import('./components/Taxes.vue')
    },
    {
      path: '/administration/mm_rates',
      name: 'mm_rates',
      // lazy-loaded
      component: () => import('./components/MoneyMarketRates.vue')
    },
    {
      path: '/administration/fees_management',
      name: 'fees_management',
      // lazy-loaded
      component: () => import('./components/FeesManagement.vue')
    },
    {
      path: '/administration/transaction_charges',
      name: 'transaction_charges',
      // lazy-loaded
      component: () => import('./components/TransactionCharges.vue')
    },
    {
      path: '/administration/charge_mapping',
      name: 'charge_mapping',
      // lazy-loaded
      component: () => import('./components/ChargeMappings.vue')
    },


    // choga edits 
    {
      path: '/administration/counter_parties',
      name: 'counterparties',
      // lazy-loaded
      component: () => import('./components/CounterParties.vue')
    },
    {
      path: '/administration/custodians',
      name: 'custodians',
      // lazy-loaded
      component: () => import('./components/Custodians.vue')
    },
    {
      path: '/administration/transactionchargerate',
      name: 'transactionchargerate',
      // lazy-loaded
      component: () => import('./components/TransactionChargeRates.vue')
    },
    {
      path: '/administration/equities',
      name: 'equities',
      // lazy-loaded
      component: () => import('./components/Equity.vue')
    },
    {
      path: '/administration/equity_prices',
      name: 'equity_prices',
      // lazy-loaded
      component: () => import('./components/EquityPrices.vue')
    },
    {
      path: '/administration/ul_equities',
      name: 'ul_equities',
      // lazy-loaded
      component: () => import('./components/EquitiesUnlisted.vue')
    },
    {
      path: '/administration/ul_equity_prices',
      name: 'ul_equity_prices',
      // lazy-loaded
      component: () => import('./components/EquityUnlistedPrices.vue')
    },
    {
      path: '/administration/bonds',
      name: 'bonds',
      // lazy-loaded
      component: () => import('./components/Bonds.vue')
    },
    {
      path: '/administration/properties',
      name: 'properties',
      // lazy-loaded
      component: () => import('./components/Property.vue')
    },
    {
      path: '/administration/property_prices',
      name: 'property_prices',
      // lazy-loaded
      component: () => import('./components/PropertyPrices.vue')
    },
    {
      path: '/administration/exchange_rates',
      name: 'exchange_rates',
      // lazy-loaded
      component: () => import('./components/DailyExchanges.vue')
    },
    {
      path: '/administration/confirmation_settings',
      name: 'confirmation_settings',
      // lazy-loaded
      component: () => import('./components/ConfirmationSettings.vue')
    },
    {
      path: '/administration/dealers',
      name: 'dealers',
      // lazy-loaded
      component: () => import('./components/Dealers.vue')
    },
    {
      path: '/tools/period_end',
      name: 'period_end',
      // lazy-loaded
      component: () => import('./components/PeriodEnd.vue')
    },
    {
      path: '/tools/period_definations',
      name: 'period_definations',
      // lazy-loaded
      component: () => import('./components/Periods.vue')
    },
    {
      path: '/tools/application_defaults',
      name: 'application_defaults',
      // lazy-loaded
      component: () => import('./components/ApplicationDefaults.vue')
    },
    {
      path: '/transactions/contributions',
      name: 'contributions',
      // lazy-loaded
      component: () => import('./components/Deposits.vue')
    },
    {
      path: '/transactions/withdrawals',
      name: 'withdrawals',
      // lazy-loaded
      component: () => import('./components/Withdrawals.vue')
    },
    {
      path: '/transactions/income_transactions',
      name: 'income_transactions',
      // lazy-loaded
      component: () => import('./components/IncomeTransactions.vue')
    },
    {
      path: '/transactions/credit_adjustments',
      name: 'credit_adjustments',
      // lazy-loaded
      component: () => import('./components/CreditAdjustment.vue')
    },
    {
      path: '/transactions/debit_adjustments',
      name: 'debit_adjustments',
      // lazy-loaded
      component: () => import('./components/DebitAdjustment.vue')
    },
    {
      path: '/transactions/settlements',
      name: 'settlements',
      // lazy-loaded
      component: () => import('./components/Settlements.vue')
    },
    {
      path: '/transactions/deal_settlements',
      name: 'deal_settlements',
      // lazy-loaded
      component: () => import('./components/DealSettlements.vue')
    },
    {
      path: '/transactions/dividend_settlements',
      name: 'dividend_settlements',
      // lazy-loaded
      component: () => import('./components/DividendSettlements.vue')
    },
    {
      path: '/transactions/fee_settlements',
      name: 'fee_settlements',
      // lazy-loaded
      component: () => import('./components/FeeSettlements.vue')
    },
    {
      path: '/transactions/dividends',
      name: 'dividends',
      // lazy-loaded
      component: () => import('./components/Dividends.vue')
    },
    {
      path: '/dealing/bond_purchases',
      name: 'bond_purchases',
      // lazy-loaded
      component: () => import('./components/PurchaseBond.vue')
    },
    {
      path: '/dealing/property_purchases',
      name: 'property_purchases',
      // lazy-loaded
      component: () => import('./components/PurchaseProperty.vue')
    },
    {
      path: '/dealing/equity_purchases',
      name: 'equity_purchases',
      // lazy-loaded
      component: () => import('./components/PurchaseEquity.vue')
    },
    {
      path: '/dealing/MM_purchases',
      name: 'MM_purchases',
      // lazy-loaded
      component: () => import('./components/PurchaseMoneyMarket.vue')
    },
    {
      path: '/dealing/MM_sales',
      name: 'MM_sales',
      // lazy-loaded
      component: () => import('./components/SellMoneyMarket.vue')
    },
    {
      path: '/dealing/equity_sales',
      name: 'equity_sales',
      // lazy-loaded
      component: () => import('./components/SellEquity.vue')
    },
    {
      path: '/dealing/bond_sales',
      name: 'bond_sales',
      // lazy-loaded
      component: () => import('./components/SellBond.vue')
    },
    {
      path: '/dealing/property_sales',
      name: 'property_sales',
      // lazy-loaded
      component: () => import('./components/SellProperty.vue')
    },
    {
      path: '/dealing/internal_asset_transfer',
      name: 'internal_asset_transfer',
      // lazy-loaded
      component: () => import('./components/InternalAssetTransfer.vue')
    },
    {
      path: '/dealing/reversals',
      name: 'reversals',
      // lazy-loaded
      component: () => import('./components/Reversal.vue')
    },
    {
      path: '/userConfirmed/:token',
      name: 'userConfirmed',
      // lazy-loaded
      component: () => import('./components/UserConfirmed')
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      // lazy-loaded
      component: () => import('./components/ForgotPassword')
    },
    {
      path: '/reset_password/:token',
      name: 'reset_password',
      // lazy-loaded
      component: () => import('./components/ResetPassword')
    },
    {
      path: '/home',
      name: 'home',
      // lazy-loaded
      component: () => import('./components/Dashboard.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['login', 'logintoken', 'forgot_password', 'userConfirmed', 'reset_password'];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/');
  } else {
    next();
  }
});
